import React, { useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { DownOutline, SearchOutline, CloseCircleFill } from 'antd-mobile-icons'
import { Popup, Button, Badge, Ellipsis, Input } from 'antd-mobile'
import intl from 'react-intl-universal'

import FilterIcon from '../../../../components/Icon/FilterIcon'
import styles from './con.module.less'
import Header from '../../../../components/Header'
import { selectConCheckItems, setConditionBar } from '../../../../store/reducers/spa'
import TagShowBox from './TagShowBox'
import { addBehaviorsRecord } from '../../../../utils/BehaviorstatsHelp'


const ConditionBar = ({ tagList = [], typeList = [], callback, productCallback, tagCallback, products = [], showSearch = false }) => {
    const conCheckItems = useSelector(selectConCheckItems)
    const { typeArr, tagArr } = conCheckItems
    console.log(conCheckItems, '====///=====')

    const dispatch = useDispatch()

    // const handleDelTag = (item) => {
    //     dispatch(setConditionBar({
    //         ...conCheckItems,
    //         tagArr: tagArr.filter(tag => tag.relateTag !== item.relateTag)
    //     }))
    //     tagCallback && tagCallback(tagArr.filter(tag => tag.relateTag !== item.relateTag))
    // }

    const [typeVisible, setTypeVisible] = useState(false)
    const [tagVisible, setTagVisible] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [fullKeyword, setFullKeyword] = useState('')

    const getPlainText = (text = '') => String(text).replace(/<[^>]+>/g, '').trim()

    const filteredTypeList = useMemo(() => {
        const keyword = searchKeyword.trim().toLowerCase()
        if (!keyword) return typeList
        return typeList.filter(item => getPlainText(item.label).toLowerCase().includes(keyword))
    }, [typeList, searchKeyword])

    const filteredProducts = useMemo(() => {
        //重复的product只显示一个
        const uniqueProducts = products.filter((item, index, self) =>
            index === self.findIndex((t) => t.productId === item.productId)
        )
        const keyword = searchKeyword.trim().toLowerCase()
        if (!keyword) return uniqueProducts
        return uniqueProducts.filter(item => getPlainText(item.productName || item.name || item.label).toLowerCase().includes(keyword))
    }, [products, searchKeyword])

    const handleSelectType = (item) => {
        setTypeVisible(false)
        dispatch(setConditionBar({
            ...conCheckItems,
            typeArr: [item]
        }))
        callback(item)

        addBehaviorsRecord({
            behaviorType: 160200,
            behavior: 160207,
            value1: item.value,
        })
    }

    const handleSelectProduct = (item) => {
        setFullKeyword(item.productName)
        setTypeVisible(false)
        productCallback && productCallback(item)
    }

    const hasKeyword = searchKeyword.trim().length > 0

    const handleClearInput = () => {
        setSearchKeyword('')
        setFullKeyword('')
    }

    return (
        <>
            <div className={`${styles.conBar} jm-flex`} style={{ marginTop: 15 }}>
                <div className={`${styles.conForm} jm-flex-item`}>
                    <div className={`${styles.conFormInner} jm-flex`} onClick={() => setTypeVisible(true)}>
                        <div><SearchOutline fontSize={20} color='#aaa5a5' /></div>
                        <div className='jm-flex-item'>
                            {
                                fullKeyword || typeArr.length > 0
                                    ?
                                    <Ellipsis content={fullKeyword || typeArr[0].label} />
                                    :
                                    <span style={{ color: '#aaa5a5' }}>
                                        {showSearch ? intl.get('h_search').d('搜索') : intl.get('sel_type').d('选择类型')}&nbsp;
                                    </span>
                            }
                        </div>
                        <div><DownOutline color='#aaa5a5' /></div>
                    </div>
                </div>
                <Badge content={tagArr.length > 0 ? tagArr.length : null} >
                    <div
                        className={`${styles.conRight}`}
                        onClick={() => setTagVisible(true)}
                    >
                        <FilterIcon width={24} height={24} color="#fff" />
                    </div>
                </Badge>
            </div>
            {
                // tagArr.length > 0 && (
                //     <div style={{ padding: '10px 20px 1px' }}>
                //         <ul className={`jm-flex ${styles.tagList} ${styles.chkTagList}`}>
                //             {
                //                 tagArr.map(item => (
                //                     <li className={styles.tagActive} key={item.relateTag}>
                //                         {item.tagName}
                //                         <div className={styles.btnDel} onClick={() => handleDelTag(item)}><CloseCircleOutline fontSize={24} /></div>
                //                     </li>
                //                 ))
                //             }
                //         </ul>
                //     </div>
                // )
            }
            <Popup
                visible={typeVisible}
                position='top'
                destroyOnClose
                onClose={() => setTypeVisible(false)}
                onMaskClick={() => setTypeVisible(false)}>

                <div>
                    <Header title={showSearch ? intl.get('h_search').d('搜索') : intl.get('sel_type').d('选择类型')} callback={() => setTypeVisible(false)} />
                    {
                        showSearch && (
                            <div className={styles.conSearchBox}>
                                <div className='jm-flex-item'>
                                    <Input
                                        value={searchKeyword}
                                        onChange={val => setSearchKeyword(val)}
                                        placeholder={intl.get('pls_input_x', { word: '...' }).d('Please input...')}
                                    />
                                </div>
                                {
                                    hasKeyword && (
                                        <div className={styles.conSearchClearBtn} onClick={handleClearInput}>
                                            <CloseCircleFill fontSize={18} color='#c2c2c2' />
                                        </div>
                                    )
                                }
                                <div className={styles.conSearchBtn}>
                                    <SearchOutline fontSize={20} color='#aaa5a5' />
                                </div>
                            </div>
                        )
                    }
                    <br />
                    <div style={{ padding: 12, maxHeight: '80vh', overflowY: 'auto' }}>
                        {
                            typeVisible
                                ?
                                hasKeyword
                                    ? (
                                        <>
                                            {
                                                filteredTypeList.length > 0 || filteredProducts.length > 0
                                                    ? (
                                                        <div className={styles.searchResultWrapper}>
                                                            {
                                                                filteredTypeList.length > 0 && (
                                                                    <>
                                                                        <div className={styles.searchResultTitle}>{intl.get('h_category').d('分类')}</div>
                                                                        {
                                                                            filteredTypeList.map((item, index) => (
                                                                                <div
                                                                                    key={`${item.value}-${index}`}
                                                                                    className={styles.searchResultItem}
                                                                                    onClick={() => {
                                                                                        setFullKeyword(item.label)
                                                                                        handleSelectType(item)
                                                                                    }}
                                                                                >
                                                                                    {getPlainText(item.label)}
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                products.length > 0 && filteredProducts.length > 0 && (
                                                                    <>
                                                                        <div className={styles.searchResultTitle}>{intl.get('h_product').d('产品')}</div>
                                                                        {
                                                                            filteredProducts.map((item, index) => (
                                                                                <div
                                                                                    key={`${item.id || item.productId || index}`}
                                                                                    className={styles.searchResultItem}
                                                                                    onClick={() => handleSelectProduct(item)}
                                                                                >
                                                                                    {getPlainText(item.productName || item.name || item.label)}
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                    : <div className={styles.searchEmpty}>{intl.get('domNoData').d('暂无数据')}</div>
                                            }
                                        </>
                                    )
                                    : (
                                        <div className='jm-flex' style={{ flexWrap: 'wrap' }}>
                                            {
                                                typeList.map((item, index) => (
                                                    <Button
                                                        style={{ marginRight: 10, marginBottom: 10, wordBreak: 'break-all' }}
                                                        key={index}
                                                        shape='rounded'
                                                        onClick={() => handleSelectType(item)}>
                                                        <div style={{ padding: '0 25px' }}>{item.label}</div>
                                                    </Button>
                                                ))
                                            }
                                        </div>
                                    )
                                : null
                        }

                    </div>
                    <br />
                </div>
            </Popup>
            <Popup
                visible={tagVisible}
                position='top'
                destroyOnClose
                onClose={() => setTagVisible(false)}
                onMaskClick={() => setTagVisible(false)}>
                <div>
                    <Header
                        title={intl.get('sel_tag').d('选择标签')}
                        callback={() => setTagVisible(false)} />
                    <br />
                    {/* <div className='p10'>
                        <div className={styles.tagShowBox}>
                            <div className='jm-flex'>
                                {
                                    tmpTagArr.map((item, index) => {
                                        return <div className={styles.tagCheckItem} key={index}>
                                            <div className='jm-flex-item'>{item.tagName}</div>
                                            <div
                                                onClick={() => {
                                                    setTmpTagArr(pre => pre.filter(tag => tag.relateTag !== item.relateTag))
                                                }}>
                                                <CloseOutline />
                                            </div>
                                        </div>

                                    })
                                }
                            </div>

                        </div>
                    </div>
                    <ul className={styles.tagList} style={{ padding: 12 }}>
                        {
                            tagList.map(item => (
                                <li
                                    className={tmpTagArr.includes(item) ? styles.tagActive : ''}
                                    key={item.id}
                                    onClick={() => {
                                        if (tmpTagArr.includes(item)) {
                                            setTmpTagArr(pre => pre.filter(tag => tag.relateTag !== item.relateTag))
                                        } else {
                                            setTmpTagArr(pre => [...pre, item])
                                        }
                                        console.log(tmpTagArr, '====///=====')
                                    }}>
                                    <Ellipsis content={item.tagName} />
                                </li>
                            ))
                        }
                    </ul>
                    <div className='m-t-sm text-center'>
                        <Space style={{ '--gap': '30px' }} >
                            <Button
                                style={{
                                    padding: '5px 35px',
                                    color: 'var(--adm-color-primary)',
                                    borderColor: 'var(--adm-color-primary)'
                                }}
                                shape='rounded'
                                onClick={() => {
                                    setTmpTagArr([])
                                }}>{intl.get('reset').d('重置')}</Button>
                            <Button
                                color='primary'
                                style={{ padding: '5px 35px' }}
                                shape='rounded'
                                onClick={() => {
                                    setTagVisible(false)
                                    dispatch(setConditionBar({
                                        ...conCheckItems,
                                        tagArr: tmpTagArr
                                    }))
                                    tagCallback && tagCallback(tmpTagArr)
                                }}>{intl.get('ok').d('确定')}</Button>
                        </Space>
                    </div> */}

                    <TagShowBox
                        tagList={tagList}
                        tagCallback={(arr) => {
                            setTagVisible(false)
                            tagCallback(arr)
                            addBehaviorsRecord({
                                behaviorType: 160200,
                                behavior: 160208,
                                value1: arr.map(item => item.id).join(','),
                                value2: arr.map(item => item.relateTag).join(',')
                            })
                        }}
                    />
                    <br />
                </div>
            </Popup>
        </>

    )
}

export default ConditionBar
